<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
                :text="modalText"
                id="modal_show1"
        />

        <ModalPushScale id="scale" text="scale.name" />

        <div class="container pt-4">
            <b-button
                variant="primary"
                class="focus:ring-0"
                id="order"
                @click="showModal"
            >
                {{ $t('add') }}
            </b-button>
        </div>

        <table class="mt-4 mx-3.5">
            <thead class="h-11 bg-lightGray">
            <tr class="font-bold">
                <td class="px-3">#</td>
                <td class="px-3">{{ $t('scale.name') }}</td>
                <td class="px-3">{{ $t('scale.token') }}</td>
                <td></td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="scale of getScales" :key="scale.id" class="h-11">
                <td class="px-3">{{ scale.id }}</td>
                <td class="px-3">{{ scale.name }}</td>
                <td class="px-3" style="overflow-wrap: anywhere">
                  {{ appBaseUrl + scale.token }}
                </td>
                <td class="px-3">
                    <img src="/images/file-copy.png" alt="" class="h-8 cursor-pointer"  @click="copy(appBaseUrl + scale.token)">
                </td>
            </tr>
            </tbody>
        </table>

    </Row>
</template>

<script>
import Row from "@/components/html/Row.vue";
import {mapActions, mapGetters} from "vuex";
import Modal from "@/components/html/Modal.vue";
import ModalPushScale from "@/components/ModalPushScale.vue";

export default {
    name: "List",
    components: {ModalPushScale, Modal, Row},
    data() {
        return {
            appBaseUrl: process.env.VUE_APP_API_URL + '/api/scales/file?token=',
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'warehouse.title', url: 'warehouses'},
                {name: 'product.title', url: 'products'},
                {name: 'scale.title'},
            ],
            search: {
                page: 1
            },
            modalText: '',
            isCopied: false
        }
    },
    computed: {
        ...mapGetters(['getScales'])
    },
    methods: {
        ...mapActions(['pushScale', 'fetchScales', 'setBreadcrumbItems']),
        showModal() {
            this.$bvModal.show('scale')
        },
        async copy(s) {
            await navigator.clipboard.writeText(s)
            this.$i18nHelper.flash('Copied!', 'info', 1)
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true
        this
            .fetchScales(this.search)
            .then(() => {
                this.$root.showOverlay = false
            })
    }
}
</script>

<style scoped>
table tbody tr {
    border-bottom: 1px solid #eaeaea;
}
</style>
